import React, { Component, createRef } from 'react'
import jarvisWidgetsDefaults from './WidgetDefaults'

class WidgetGrid extends Component {
  constructor(props) {
    super(props)
    this.gridRef = createRef()
  }

  componentDidMount() {
    $(this.gridRef.current).jarvisWidgets(jarvisWidgetsDefaults)
  }

  render() {
    return (
      <section id="widget-grid" ref={this.gridRef}>
        {this.props.children}
      </section>
    )
  }
}

export default WidgetGrid
